<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">

              <!-- Incapacité temporaire de travail (ITT) -->
              <div class="section-card">
                <div class="section-title">Incapacité temporaire de travail (ITT)</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Montant mensuel" [derrors]="derrors" [suffix]="'€/mois'">
                      <input formControlName="ittMontantMensuel" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Frais généraux mensuels" [derrors]="derrors" [suffix]="'€/mois'">
                      <input formControlName="ittFraisGenerauxMensuels" type="text" [placeholder]="fraisGenerauxPlaceholder" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-column label="Franchises" [derrors]="derrors">
                      <input formControlName="ittFranchises" type="text" placeholder="" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="ittRenfortDos"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Renfort dos"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="ittAffectionPsy"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Affection psy"
                    ></pr-input-radio>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Délais d'attente" [derrors]="derrors">
                      <input formControlName="ittDelaisAttente" type="text" placeholder="" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="ittMiTempsTherapeutique"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Mi-temps thérapeutique"
                    ></pr-input-radio>
                  </div>
                </div>
              </div>

              <!-- Invalidité -->
              <div class="section-card">
                <div class="section-title">Invalidité</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Montant mensuel" [derrors]="derrors" [suffix]="'€/mois'">
                      <input formControlName="invaliditeMontantMensuel" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Barème d'invalidité" [derrors]="derrors">
                      <pr-select-search
                        formControlName="invaliditeBareme"
                        label="Barème d'invalidité"
                        [options]="baremeOptions"
                      ></pr-select-search>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Seuil de déclenchement" [derrors]="derrors" [suffix]="'%'">
                      <input formControlName="invaliditeSeuilDeclenchement" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Décès / PTIA -->
              <div class="section-card">
                <div class="section-title">Décès / PTIA</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="Montant" [derrors]="derrors" [suffix]="'€'">
                      <input formControlName="decesPtiaMontant" type="text" [placeholder]="decesPtiaPlaceholder" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Cotisations -->
              <div class="section-card">
                <div class="section-title">Cotisations</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Cotisation mensuelle" [derrors]="derrors">
                      <input formControlName="cotisationMensuelle" type="text" placeholder="" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Cotisation Madelin" [derrors]="derrors">
                      <input formControlName="cotisationMadelin" type="text" placeholder="" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Commentaire -->
              <div class="section-card">
                <div class="section-title">Commentaire</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="commentaire" rows="3" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
